import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowRight, FiCheckCircle, FiTarget, FiZap } = FiIcons;

function CaseStudyProofBlock({ caseStudy }) {
  return (
    <div className="bg-white rounded-2xl border border-slate-200 shadow-sm hover:shadow-md transition-all p-6 sm:p-8">
      <div className="flex items-start gap-4 mb-6">
        <div className="bg-blue-100 p-2 rounded-lg shrink-0">
          <SafeIcon icon={FiCheckCircle} className="h-5 w-5 text-blue-600" />
        </div>
        <div className="flex-grow">
          <h3 className="text-lg font-bold text-slate-900 mb-1">{caseStudy.title}</h3>
          <p className="text-xs font-bold text-blue-600 uppercase tracking-wider">{caseStudy.industry}</p>
        </div>
      </div>

      <div className="space-y-5 mb-6">
        <div>
          <div className="flex items-center gap-2 mb-2">
            <SafeIcon icon={FiTarget} className="h-4 w-4 text-slate-400" />
            <span className="text-xs font-bold text-slate-500 uppercase tracking-wider">Problem</span>
          </div>
          <p className="text-sm text-slate-700 leading-relaxed">{caseStudy.problem}</p>
        </div>

        <div>
          <div className="flex items-center gap-2 mb-2">
            <SafeIcon icon={FiZap} className="h-4 w-4 text-slate-400" />
            <span className="text-xs font-bold text-slate-500 uppercase tracking-wider">Solution</span>
          </div>
          <p className="text-sm text-slate-700 leading-relaxed">{caseStudy.solution}</p>
        </div>

        <div className="pt-4 border-t border-slate-100">
          <div className="flex items-center gap-2 mb-2">
            <SafeIcon icon={FiCheckCircle} className="h-4 w-4 text-green-600" />
            <span className="text-xs font-bold text-green-700 uppercase tracking-wider">Outcome</span>
          </div>
          <p className="text-sm text-slate-700 font-medium leading-relaxed">{caseStudy.outcome}</p>
        </div>
      </div>

      {caseStudy.serviceLinks && caseStudy.serviceLinks.length > 0 && (
        <div className="flex flex-wrap gap-2 pt-6 border-t border-slate-100">
          {caseStudy.serviceLinks.map((service, idx) => (
            <Link
              key={idx}
              to={`/services/${service.slug}`}
              className="text-[11px] font-bold uppercase tracking-widest px-3 py-1.5 bg-slate-50 text-slate-600 border border-slate-200 rounded-full hover:bg-blue-50 hover:text-blue-600 hover:border-blue-200 transition-all"
            >
              {service.name}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

export default CaseStudyProofBlock;